<template>
  <section class="loyalty-header small-margin-top-xs medium-margin-top-z margin-bottom-xl">
    <LoyaltyHeaderStatus />
  </section>
</template>

<script setup>
import LoyaltyHeaderStatus from './LoyaltyHeaderStatus';
</script>
